import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SiteConfig } from '../../client-core/dtos/users.model';
import { UserService } from '../../client-core/services/user.service';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[siteConfiguration]',
    // tslint:disable-next-line:use-input-property-decorator
    inputs: ['siteConfiguration']
})
export class SiteConfigDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userService: UserService) { }

    @Input()
    set siteConfiguration(requiredConfig: SiteConfig) {
        let shouldShow = false;
        this.userService.getSiteConfig()
            .subscribe(res => {
                console.log('getSiteConfig res', res);
                if (!res.hasError) {
                    const index = res.data.findIndex((config) => {
                        return config.configuration === requiredConfig.configuration && config.operation === requiredConfig.operation;
                    });

                    shouldShow = index > -1;
                }
            }, err => {
                console.log(err);
            }, () => {
                if (shouldShow) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                } else {
                    this.viewContainer.clear();
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/config.directive.ts